import useTermCategories from '@hooks/term/useTermCategories';
import { useContext, useEffect } from 'react';

import SignUpContext from '../../../context/SignUpContext';

function useAgreement() {
    const {
        useMarketing, useLocation, useSelectedTermCategories,
    } = useContext(SignUpContext);
    const [marketing, setMarketing] = useMarketing;
    const [location, setLocation] = useLocation;
    const termCategories = useTermCategories('SIGN_UP');
    const [selectedTermCategories, setSelectedTermCategories] = useSelectedTermCategories;

    const isAllChecked = selectedTermCategories.length === termCategories.length
      && marketing && location;
    const agreeAll = () => {
        const newValue = !isAllChecked;
        if (newValue) {
            setSelectedTermCategories(
                termCategories.map((category) => category.id),
            );
        } else {
            setSelectedTermCategories([]);
        }
        setMarketing(newValue);
        setMarketing(newValue);
        setLocation(newValue);
    };
    const toggleTermCategory = (termCategoryId: string) => {
        if (selectedTermCategories.includes(termCategoryId)) {
            setSelectedTermCategories(
                selectedTermCategories.filter((id) => id !== termCategoryId),
            );
        } else {
            setSelectedTermCategories([...selectedTermCategories, termCategoryId]);
        }
    };

    useEffect(() => {
        const locationTerm = termCategories
            .find((category) => category.type === 'LOCATION_TERMS');
        const marketingTerm = termCategories
            .find((category) => category.type === 'MARKETING_TERMS');

        if (locationTerm) {
            setLocation(selectedTermCategories.includes(locationTerm.id));
        }
        if (marketingTerm) {
            setMarketing(selectedTermCategories.includes(marketingTerm.id));
        }
    }, [selectedTermCategories, termCategories]);

    const isChecked = (termCategoryId: string) => selectedTermCategories.includes(termCategoryId);
    return {
        marketing,
        setMarketing,
        location,
        setLocation,
        isAllChecked,
        agreeAll,
        termCategories,
        toggleTermCategory,
        isChecked,
    };
}

export default useAgreement;
